export default __webpack_public_path__ + "static/media/Bluenet Controllers.731b1b52.jpg";